module.exports = __webpack_public_path__ + "img/webpage-icon-active.d493f17a.svg";